{
  "readingAid": {
    "de": "Lesehilfe",
    "en": "Reading Aid",
    "fr": "Aide à la lecture",
    "pl": "Pomoc w czytaniu",
    "nl": "Leeshulp"
  },
  "simpleLang": {
    "de": "Einfache Sprache",
    "en": "Simple Language",
    "fr": "Langage simple",
    "pl": "Prosty język",
    "nl": "Eenvoudige taal"
  },
  "enlargedButtons": {
    "de": "Schaltflächen vergrößern",
    "en": "Enlarge Buttons",
    "fr": "Agrandir les boutons",
    "pl": "Powiększ przyciski",
    "nl": "Knoppen vergroten"
  },
  "stopAnimations": {
    "de": "Animationen stoppen",
    "en": "Stop Animations",
    "fr": "Arrêter les animations",
    "pl": "Zatrzymaj animacje",
    "nl": "Animaties stoppen"
  },
  "wordSpacing": {
    "de": "Wortabstand",
    "en": "Word Spacing",
    "fr": "Espacement des mots",
    "pl": "Odstęp między słowami",
    "nl": "Woordafstand"
  },
  "cursorSize": {
    "de": "Zeigergröße",
    "en": "Cursor Size",
    "fr": "Taille du curseur",
    "pl": "Rozmiar kursora",
    "nl": "Cursorgrootte"
  },
  "lineHeight": {
    "de": "Zeilenabstand",
    "en": "Line Height",
    "fr": "Interligne",
    "pl": "Wysokość linii",
    "nl": "Regelhoogte"
  },
  "letterSpacing": {
    "de": "Buchstabenabstand",
    "en": "Letter Spacing",
    "fr": "Espacement des lettres",
    "pl": "Odstęp między literami",
    "nl": "Letterafstand"
  },
  "fontSize": {
    "de": "Schriftgröße",
    "en": "Font Size",
    "fr": "Taille de police",
    "pl": "Rozmiar czcionki",
    "nl": "Lettergrootte"
  },
  "contrastMode": {
    "de": "Kontrast-Modus",
    "en": "Contrast Mode",
    "fr": "Mode de contraste",
    "pl": "Tryb kontrastu",
    "nl": "Contrastmodus"
  },
  "contrastNormal": {
    "de": "Normal",
    "en": "Normal",
    "fr": "Normal",
    "pl": "Normalny",
    "nl": "Normaal"
  },
  "contrastGrayscale": {
    "de": "Graustufen",
    "en": "Grayscale",
    "fr": "Niveaux de gris",
    "pl": "Skala szarości",
    "nl": "Grijstinten"
  },
  "contrastInverted": {
    "de": "Invertiert",
    "en": "Inverted",
    "fr": "Inversé",
    "pl": "Odwrócony",
    "nl": "Omkeren"
  },
  "contrastHigh": {
    "de": "Hoher Kontrast",
    "en": "High Contrast",
    "fr": "Contraste élevé",
    "pl": "Wysoki kontrast",
    "nl": "Hoog contrast"
  },
  "a11y": {
    "de": "Barrierefreiheit",
    "en": "Accessibility",
    "fr": "Accessibilité",
    "pl": "Dostępność",
    "nl": "Toegankelijkheid"
  },
  "openA11ySettingsAria": {
    "de": "Barrierefreiheitseinstellungen öffnen",
    "en": "Open accessibility settings",
    "fr": "Ouvrir les paramètres d'accessibilité",
    "pl": "Otwórz ustawienia dostępności",
    "nl": "Toegankelijkheidsinstellingen openen"
  },
  "closeA11ySettingsAria": {
    "de": "Barrierefreiheitseinstellungen schließen",
    "en": "Close accessibility settings",
    "fr": "Fermer les paramètres d'accessibilité",
    "pl": "Zamknij ustawienia dostępności",
    "nl": "Toegankelijkheidsinstellingen sluiten"
  },
  "resetAll": {
    "de": "Alle Einstellungen zurücksetzen",
    "en": "Reset all settings",
    "fr": "Réinitialiser tous les paramètres",
    "pl": "Zresetuj wszystkie ustawienia",
    "nl": "Alle instellingen resetten"
  },
  "simpleLanguageLabel": {
    "de": "Zur einfachen Sprache wechseln",
    "en": "Switch to simple language",
    "fr": "Passer au langage simple",
    "pl": "Przełącz na prosty język",
    "nl": "Overschakelen naar eenvoudige taal"
  },
  "skipToMain": {
    "de": "Zum Hauptinhalt",
    "en": "Skip to main content",
    "fr": "Aller au contenu principal",
    "pl": "Przejdź do głównej treści",
    "nl": "Ga naar hoofdinhoud"
  },
  "skipToA11y": {
    "de": "Zu den Barrierefreiheitseinstellungen",
    "en": "Go to accessibility settings",
    "fr": "Aller aux paramètres d'accessibilité",
    "pl": "Przejdź do ustawień dostępności",
    "nl": "Ga naar toegankelijkheidsinstellingen"
  },
  "a11yDisclaimer": {
    "de": "Zur Barrierefreiheitserklärung",
    "en": "Go to accessibility statement",
    "fr": "Aller à la déclaration d'accessibilité",
    "pl": "Przejdź do oświadczenia o dostępności",
    "nl": "Ga naar toegankelijkheidsverklaring"
  },
  "a11yContact": {
    "de": "Kontakt aufnehmen zum Thema Barrierefreiheit",
    "en": "Contact about accessibility",
    "fr": "Contacter au sujet de l'accessibilité",
    "pl": "Skontaktuj się w sprawie dostępności",
    "nl": "Contact opnemen over toegankelijkheid"
  },
  "enabled": {
    "de": "aktiviert",
    "en": "enabled",
    "fr": "activé",
    "pl": "włączone",
    "nl": "ingeschakeld"
  },
  "disabled": {
    "de": "deaktiviert",
    "en": "disabled",
    "fr": "désactivé",
    "pl": "wyłączone",
    "nl": "uitgeschakeld"
  },
  "decreaseAria": {
    "de": "verringern",
    "en": "decrease",
    "fr": "diminuer",
    "pl": "zmniejsz",
    "nl": "verlagen"
  },
  "increaseAria": {
    "de": "erhöhen",
    "en": "increase",
    "fr": "augmenter",
    "pl": "zwiększ",
    "nl": "verhogen"
  },
  "resetAria": {
    "de": "zurücksetzen",
    "en": "reset",
    "fr": "réinitialiser",
    "pl": "zresetuj",
    "nl": "resetten"
  },
  "settings": {
    "de": "Einstellungen",
    "en": "Settings",
    "fr": "Paramètres",
    "pl": "Ustawienia",
    "nl": "Instellingen"
  },
  "close": {
    "de": "Schließen",
    "en": "Close",
    "fr": "Fermer",
    "pl": "Zamknij",
    "nl": "Sluiten"
  }
}